module.exports = __webpack_public_path__ + "static/media/0089_Medium.05ffd60b.jpg";